import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sortiereProdukte } from '../utils/sortHelpers';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Paper,
  Checkbox, Alert, Button, Grid
} from '@mui/material';

// function tageBisVerfall(verfallsdatum) {
//   const heute = new Date();
//   const verfall = new Date(verfallsdatum);
//   const diffTime = verfall - heute;
//   return Math.floor(diffTime / (1000 * 60 * 60 * 24));
// }

export default function VorratsInventurTabelle() {
  const [produkte, setProdukte] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const navigate = useNavigate();

  // für Sortierung
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    fetch('https://app.satoha.de/service/?modus=get-vorrat-liste-inventur')
      .then(res => res.json())
      .then(data => {
        setProdukte(data);
        setLoading(false);
      })
      .catch(() => {
        setErrorMsg('Fehler beim Laden der Daten.');
        setLoading(false);
      });
  }, []);

  const handleCheckboxChange = async (dbid) => {
    try {
      const response = await fetch('https://app.satoha.de/service/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ modus: 'set-inventur', item_dbid: dbid, inventur: 1 }),
      });
      const result = await response.json();
      if (result.success) {
        setSuccessMsg(result.message || 'Inventur aktualisiert.');
        setProdukte(prev => prev.filter(p => p.dbid !== dbid));
      } else {
        setErrorMsg(result.message || 'Fehler beim Aktualisieren der Inventur.');
      }
    } catch (err) {
      setErrorMsg('Netzwerkfehler beim Aktualisieren der Inventur.');
    }
  };

  const handleLoeschen = async (dbid) => {
    if (!window.confirm("Willst du dieses Produkt wirklich löschen?")) return;
    try {
      const response = await fetch(
        `https://app.satoha.de/service/?action=delete-vorrat&type=id&value=${dbid}`,
        { method: 'POST' }
      );
      const result = await response.json();
      if (result.success) {
        setSuccessMsg(result.message || "Produkt gelöscht!");
        setProdukte(prev => prev.filter(p => p.dbid !== dbid));
      } else {
        setErrorMsg(result.message || "Löschen fehlgeschlagen.");
      }
    } catch (err) {
      setErrorMsg("Netzwerkfehler beim Löschen.");
    }
  };

  if (loading) return <div>Lade Daten...</div>;

  const handleSort = (field) => {
  if (sortField === field) {
    setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
  } else {
    setSortField(field);
    setSortDirection('asc');
  }
};

const handleInventurReset = async () => {
  if (!window.confirm("Soll die komplette Inventur wieder zurückgesetzt werden?")) return;
  try {
    const response = await fetch('https://app.satoha.de/service/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modus: 'reset-inventur' }),
    });
    const result = await response.json();
    if (result.success) {
      setSuccessMsg(result.message || "Inventur wurde zurückgesetzt.");
      // Optional: Tabelle neu laden
      fetch('https://app.satoha.de/service/?modus=get-vorrat-liste-inventur')
        .then(res => res.json())
        .then(data => setProdukte(data));
    } else {
      setErrorMsg(result.message || "Fehler beim Zurücksetzen der Inventur.");
    }
  } catch (err) {
    setErrorMsg("Netzwerkfehler beim Zurücksetzen der Inventur.");
  }
};


  const sortierteProdukte = sortiereProdukte(produkte, sortField, sortDirection);
  
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: 2 }}>
      <Grid container spacing={1} alignItems="center" sx={{ p: 1, mb: 1 }}>
        {/* <Grid item>
          <h2>Inventur</h2>
        </Grid> */}
        <Grid item>
            <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
            sx={{
                height: { xs: 26, sm: 44, md: 42 },
                fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' },
                px: { xs: 1.5, sm: 3, md: 3 }
            }}
            >
            Inventur verlassen
            </Button>
        </Grid>
        <Grid item>
            <Button
            variant="outlined"
            color="warning"
            onClick={handleInventurReset}
            sx={{
                height: { xs: 26, sm: 44, md: 42 },
                fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' },
                px: { xs: 1.5, sm: 3, md: 3 }
            }}
            >
            Inventur zurücksetzen
            </Button>
        </Grid>
      </Grid>
      {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}
      {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}
      <TableContainer>
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': {
              px: { xs: 0.4, sm: 2 },
              py: { xs: 1.2, sm: 1 },
              fontSize: { xs: '0.8rem', sm: '1rem' },
            }
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell><b>Inventur</b></TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'marker'}
                    direction={sortField === 'marker' ? sortDirection : 'asc'}
                    onClick={() => handleSort('marker')}
                    >
                    <b>Marker</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'name'}
                    direction={sortField === 'name' ? sortDirection : 'asc'}
                    onClick={() => handleSort('name')}
                >
                <b>Name</b>
            </TableSortLabel>
            </TableCell>
              <TableCell
                  sx={{
                    display: { xs: 'none', sm: 'table-cell' } // Versteckt auf xs (Handy)
                  }}
              >
                <TableSortLabel
                    active={sortField === 'menge'}
                    direction={sortField === 'menge' ? sortDirection : 'asc'}
                    onClick={() => handleSort('menge')}
                >
                    <b>Menge</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'ort'}
                    direction={sortField === 'ort' ? sortDirection : 'asc'}
                    onClick={() => handleSort('ort')}
                >
                    <b>Lagerplatz</b>
                </TableSortLabel>
              </TableCell>
              <TableCell><b>Löschen</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortierteProdukte.map(p => (
              <TableRow key={p.dbid} hover>
                <TableCell>
                  <Checkbox
                    onChange={() => handleCheckboxChange(p.dbid)}
                    inputProps={{ 'aria-label': 'Inventur bestätigen' }}
                  />
                </TableCell>
                <TableCell>#{p.marker}</TableCell>
                <TableCell>{p.name}</TableCell>
                <TableCell
                  sx={{
                    display: { xs: 'none', sm: 'table-cell' } // Versteckt auf xs (Handy)
                  }}
                >{p.menge} {p.einheit}</TableCell>
                <TableCell>{p.ort}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleLoeschen(p.dbid)}
                     sx={{
                        height: { xs: 26, sm: 44, md: 42 },
                        fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' },
                        px: { xs: 1.5, sm: 3, md: 3 }
                    }}
                  >
                    Löschen
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <br />
      </TableContainer>
    </Paper>
  );
}
